import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import Typography from '../../../Pdf/components/Typography';
import Row from '../../../Pdf/components/Row';
import theme from '../../../Pdf/components/theme';

const styles = StyleSheet.create({
  entry: {
    paddingVertical: theme.spacing(theme.spacingSizes.xxs),
    paddingHorizontal: theme.spacing(theme.spacingSizes.sm),
  },
  entryLabel: {
    fontSize: theme.spacing(theme.spacingSizes.xs),
    lineHeight: 1.5,
    paddingLeft: theme.spacing(theme.spacingSizes.xxs * 3),
  },
  subEntry: {
    paddingVertical: theme.spacing(theme.spacingSizes.xxs),
    paddingHorizontal: theme.spacing(theme.spacingSizes.sm),
    paddingLeft: theme.spacing(theme.spacingSizes.sm + theme.spacingSizes.md),
  },
  subEntryLabel: {
    fontWeight: 500,
    paddingLeft: theme.spacing(theme.spacingSizes.xxs * 3),
  },
  number: {
    width: theme.spacing(theme.spacingSizes.xs),
    fontWeight: 500,
  },
});

type Props = {
  number: string;
  label: string;
  pageStart: number;
  pageEnd: number;
  subEntry?: boolean;
};

const TableOfContentsEntry: FC<Props> = ({
  number,
  label,
  pageStart,
  pageEnd,
  subEntry = false,
}) => {
  return (
    <Row
      key={label}
      centered
      justify="space-between"
      style={subEntry ? styles.subEntry : styles.entry}
    >
      <Row centered>
        <Typography variant="body2" subtle style={styles.number}>
          {number}
        </Typography>
        <Typography
          variant={subEntry ? 'body2' : 'h6'}
          subtle={subEntry}
          style={subEntry ? styles.subEntryLabel : styles.entryLabel}
        >
          {label}
        </Typography>
      </Row>
      <Typography variant="body2" subtle>
        {pageStart === pageEnd ? pageStart : `${pageStart}-${pageEnd}`}
      </Typography>
    </Row>
  );
};

export default TableOfContentsEntry;
